export default __webpack_public_path__ + "static/media/link.f4a21b7b.svg";